import { render, staticRenderFns } from "./ConclusionIndustry.vue?vue&type=template&id=77740fa9&scoped=true&"
import script from "./ConclusionIndustry.vue?vue&type=script&lang=js&"
export * from "./ConclusionIndustry.vue?vue&type=script&lang=js&"
import style0 from "./ConclusionIndustry.vue?vue&type=style&index=0&id=77740fa9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77740fa9",
  null
  
)

export default component.exports